import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorShippingHeaderSearch = () => {
  const shippingHeaderSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction-shipping-header/search', payload, (response) => {
      loading(false)
      if (response.data) {
        callback(response.data)
      }
    })
  }, [])

  return { shippingHeaderSearch }
}

export default InteractorShippingHeaderSearch
